import React from 'react';
import classNames from 'classnames/bind';
import EventBanner from './EventBanner';
import EventCTA from './EventCTA';
import EventTimer from '../EventTimer';
import Text from '../../../atoms/Text';
import {
  EVENT_PRESALE_BOTTOM_CONTENT1,
  EVENT_PRESALE_BOTTOM_CONTENT2,
  EVENT_ACTIVESALE_BOTTOM_CONTENT1,
  EVENT_POSTSALE_TOP_CONTENT1,
  EVENT_POSTSALE_TOP_CONTENT2,
  EVENT_POSTSALE_BOTTOM_CONTENT1
} from '../Constants';
import styles from './index.pcss';

export interface EventCardDataProps {
  eventType: string;
  eventLabel?: string;
  eventDescripton?: string;
  eventStartsIn?: number;
  eventEndsIn?: number;
  eventBannerUrl: string;
  eventIcon: string;
  eventTimerPrefix?: string;
  ctaLabel?: string;
}

interface EventCardProps {
  platform: string;
  onTimerComplete: () => void;
  onCTAClick: (PAGE_TYPE: string) => void;
  shopMoreUrl: string;
  eventCardData: EventCardDataProps;
}

const cx = classNames.bind(styles);

const EventCard = (props: EventCardProps): JSX.Element => {
  const {
    platform = '',
    onTimerComplete,
    eventCardData: {
      eventType = '',
      eventLabel = '',
      eventDescripton = '',
      eventStartsIn = 0,
      eventEndsIn = 0,
      eventBannerUrl = '',
      eventIcon = '',
      eventTimerPrefix = '',
      ctaLabel = ''
    } = {},
    onCTAClick,
    shopMoreUrl = ''
  } = props;

  let topComponent = null;
  let bottomComponent = null;

  switch (eventType) {
    case 'PRE_SALE':
      topComponent = (
        <section className={cx('section')}>
          <div className={cx('pd-btm-8')}>
            <Text variant="T4">{eventDescripton}</Text>
          </div>
          <EventTimer
            platform={platform}
            variant="T10"
            weight="bold"
            color="Jade"
            title={eventTimerPrefix}
            eventDate={eventStartsIn}
            onTimerComplete={onTimerComplete}
            topLevelComponent="EventCard"
          />
        </section>
      );
      bottomComponent = (
        <>
          <section className={cx('section')}>
            <div>
              <Text variant="T5" weight="bold">
                {EVENT_PRESALE_BOTTOM_CONTENT1}
              </Text>
            </div>
            <div>
              <Text variant="T3">{EVENT_PRESALE_BOTTOM_CONTENT2}</Text>
            </div>
          </section>
          <EventCTA eventType={eventType} ctaLabel={ctaLabel} onCTAClick={onCTAClick} />
        </>
      );
      break;
    case 'ACTIVE_SALE':
      topComponent = (
        <section className={cx('section')}>
          <EventTimer
            platform={platform}
            variant="T10"
            weight="bold"
            color="Jade"
            title={eventTimerPrefix}
            eventDate={eventEndsIn}
            onTimerComplete={onTimerComplete}
            topLevelComponent="EventCard"
          />
        </section>
      );
      bottomComponent = (
        <>
          <section className={cx('section')}>
            <div>
              <Text variant="T4">{EVENT_ACTIVESALE_BOTTOM_CONTENT1}</Text>
            </div>
            <div>
              <Text variant="T10" weight="bold">
                {eventLabel}
              </Text>
            </div>
            <div>
              <Text variant="T4">{eventDescripton}</Text>
            </div>
          </section>
          <EventCTA eventType={eventType} ctaLabel={ctaLabel} shopMoreUrl={shopMoreUrl} />
        </>
      );
      break;
    case 'POST_SALE':
      topComponent = (
        <section className={cx('section')}>
          <div className={cx('pd-btm-8')}>
            <Text variant="T5" weight="bold">
              {EVENT_POSTSALE_TOP_CONTENT1}
            </Text>
          </div>
          <div>
            <Text variant="T4">{EVENT_POSTSALE_TOP_CONTENT2}</Text>
          </div>
        </section>
      );
      bottomComponent = (
        <>
          <section className={cx('section')}>
            <div>
              <Text variant="T3">{EVENT_POSTSALE_BOTTOM_CONTENT1}</Text>
            </div>
          </section>
        </>
      );
      break;
    default:
      topComponent = null;
      bottomComponent = null;
  }

  return (
    <article className={cx('card')}>
      {topComponent}
      {eventIcon !== '' && (
        <EventBanner platform={platform} bannerUrl={eventBannerUrl} eventIcon={eventIcon} />
      )}
      {bottomComponent}
    </article>
  );
};

export default EventCard;
